import { change } from 'redux-form';
import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import {
  fetchDecisionSplitObjectFields,
  setPathContactType,
  setPathObject,
} from '../../../actions/JourneyBuilder';
import { JOURNEY_BUILDER_FORM_NAME } from '../../../constants/JourneyBuilder';
import PathObjectsComponent from './PathObjectsComponent';

const mapStateToProps = ({
  journeyBuilderArea: {
    JourneyBuilderSettings: {
      decisionSplitObjects,
      culture,
      currentMID,
      isHCOEnabled,
      isLoadingDecisionSplitObjectFields,
      journeyId,
      isHCO,
    },
  },
}) => ({
  objects: decisionSplitObjects,
  culture,
  currentMID,
  isHCOEnabled,
  isLoadingDecisionSplitObjectFields,
  journeyId,
  isHCO,
});

export const mapDispatchToProps = dispatch => ({
  fetchObjectFieldsDispatch(objectId, locale, buID) {
    dispatch(fetchDecisionSplitObjectFields(objectId, locale, buID));
  },
  setFormValueDispatch(fieldName, value) {
    dispatch(change(JOURNEY_BUILDER_FORM_NAME, fieldName, value));
  },
  setPathObjectDispatch(index, value) {
    dispatch(setPathObject(index, value));
  },
  setPathContactTypeFieldDispatch(index, value) {
    dispatch(setPathContactType(index, value));
  },
});

export const findObject = (objects, item) => {
  const { metaData } = item;

  return (
    objects.find(x => x.id === (metaData && metaData.objectValue)) || (objects.length && objects[0])
  );
};

export const PathObjectsLoader = lifecycle({
  componentDidMount() {
    const {
      item,
      index,
      objects,
      setFormValueDispatch,
      setPathContactTypeFieldDispatch,
      setPathObjectDispatch,
      isHCO,
    } = this.props;
    const obj = findObject(objects, item);
    setFormValueDispatch(`${item.arguments.branchResult}_object`, obj.id);
    setPathObjectDispatch(index, obj.id);

    const contactType = isHCO ? 'HCO' : 'HCP';

    setFormValueDispatch(`${item.arguments.branchResult}_contactType`, contactType);
    setPathContactTypeFieldDispatch(index, contactType);
  },
})(PathObjectsComponent);

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(PathObjectsLoader);



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/Path/PathObjects.js